declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

const FB_PIXEL_ID = '846969475009809'

let initialized = false

export function initFacebookPixel(): void {
  if (initialized) return
  if (typeof window === 'undefined') return

  // Facebook Pixel base code
  const f = window
  const b = document
  const n = 'script'

  if (f.fbq) return

  const fbq = function (...args: unknown[]) {
    if ((fbq as any).callMethod) {
      ;(fbq as any).callMethod.apply(fbq, args)
    } else {
      ;(fbq as any).queue.push(args)
    }
  } as any

  if (!f._fbq) f._fbq = fbq
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = [] as unknown[][]

  f.fbq = fbq

  const s = b.createElement(n) as HTMLScriptElement
  s.async = true
  s.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = b.getElementsByTagName(n)[0]
  firstScript?.parentNode?.insertBefore(s, firstScript)

  window.fbq('init', FB_PIXEL_ID)
  window.fbq('track', 'PageView')

  // Add noscript pixel image
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${FB_PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.body.appendChild(noscript)

  initialized = true
}

export function trackViewContent(): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'ViewContent')
  }
}

export function trackInitiateCheckout(
  contentName: string,
  contentIds: string[],
  value: number,
  currency: string = 'USD',
): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout', {
      content_name: contentName,
      content_ids: contentIds,
      value,
      currency,
    })
  }
}

/**
 * Fires InitiateCheckout and navigates after a short delay
 * to ensure the pixel event is sent before redirect.
 */
export function trackAndRedirect(
  url: string,
  contentName: string,
  contentIds: string[],
  value: number,
): void {
  trackInitiateCheckout(contentName, contentIds, value)
  setTimeout(() => {
    window.open(url, '_blank', 'noopener,noreferrer')
  }, 300)
}
